var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderbolt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "23.000000pt",
    height: "42.000000pt",
    viewBox: "0 0 23.000000 42.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,42.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 301 c-22 -66 -37 -122 -34 -125 3 -3 24 -6 47 -6 l41 0 -7 -57 c-11 -89 -11 -119 2 -106 20 20 137 228 132 236 -2 4 -22 7 -44 7 -21 0 -39 1 -39 3 0 2 11 37 25 77 14 40 25 77 25 82 0 4 -24 8 -54 8 l-54 0 -40 -119z m123 82 c-11 -26 -45 -137 -45 -145 0 -5 18 -8 40 -8 22 0 40 -2 40 -5 0 -7 -92 -165 -96 -165 -2 0 -1 29 3 65 l6 65 -46 0 -46 0 36 105 35 105 40 0 c34 0 39 -3 33 -17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderbolt);
export default __webpack_public_path__ + "static/media/thunderbolt.4c48e6d55191c3042486f25b7a6db64a.svg";
export { ForwardRef as ReactComponent };